<template>
  <section>
    <h5>{{ $t('DASHBOARD.DRAFT_DOCUMENTS')}}</h5>
    <b-card no-body>

      <div v-for="(item,index) in items" :key="index">
        <ledger-draft-item v-if="item.type == 'document'" :item="item" :small="1" ></ledger-draft-item>
        <template-document-item v-if="item.type == 'template'" :item="item" :small="1"></template-document-item>
      </div>

      <b-card-body
        class="text-center"
        v-if="items.length == 0"
      >{{ $t('DASHBOARD.NO_DRAFT_DOCUMENTS')}}</b-card-body>

      <b-card-footer class="clickable text-center">
        <router-link :to="{ name: 'Documents.Drafts' }">
          <i class="fal fa-file-edit" />
          {{$t('DASHBOARD.GOTO_DRAFT_DOCUMENTS')}}
        </router-link>
      </b-card-footer>
    </b-card>
  </section>
</template>
<script>
import LedgerDraftItem from "@/components/Ledger/LedgerDraftItem";
import TemplateDocumentItem from "@/components/Templates/TemplateDocumentItem";
export default {
  components: {
    LedgerDraftItem,
    TemplateDocumentItem
  },
  data() {
    return {
      page: 0,
      limit: 3,
      items: [],
      totalItems: 0,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    getPublished: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/documents/drafts/list", {
          page: this.page,
          limit: this.limit,
          searchText: ''
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  mounted: function() {
    this.getPublished();
  }
};
</script>
<style>
</style>
